export const RECENTLY_VIEWED_UPDATED = 'recently-viewed:updated';

export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 8;
  static #products = [];

  static addProduct(productId) {
    const id = String(productId);
    if (!/^\d+$/.test(id)) return;
    this.#products = [id, ...this.getProducts().filter((savedId) => savedId !== id)].slice(0, this.#MAX_PRODUCTS);
    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(this.#products));
    } catch {}
    window.dispatchEvent(new CustomEvent(RECENTLY_VIEWED_UPDATED));
  }

  static clearProducts() {
    this.#products = [];
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch {}
    window.dispatchEvent(new CustomEvent(RECENTLY_VIEWED_UPDATED));
  }

  static getProducts() {
    try {
      const stored = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      this.#products = Array.isArray(stored)
        ? [...new Set(stored.map(String).filter((id) => /^\d+$/.test(id)))].slice(0, this.#MAX_PRODUCTS)
        : [];
    } catch {}
    return [...this.#products];
  }
}
